import { liveStreamingMode } from "../../../modes";
import { queryType } from "../../../common";
export const config = {
    alternative: false,
    colorful: false,
    mode: "Sport",
    enableAllSports: false,
    enableFavorites: false,
    isFavoritesFirst: true,
    liveStreamingMode: liveStreamingMode.firstSelected,
    enableLiveStreaming: false,
    sportOrder: [],
    blockId: "filter_block",
    query: queryType.preLive,
    hideSportIconOnMobile: true,
    sportRetrieverUpdatePeriod: 180000,
    liveStreamingUpdatePeriod: 30000,
    personalization: {
        enableForYouTab: true,
        maxPersonalizedEventsPerSport: 10,
        maxPersonalizedSports: 10,
        regionCode: "22"
    }
};
export const marketGroupsDefaultConfig = {
    mode: "Markets",
    isAllOutrightsFirst: false,
    leagueId: "",
    blockId: ""
};
//# sourceMappingURL=config.js.map